import { render, staticRenderFns } from "./myThesis.vue?vue&type=template&id=127767c0&scoped=true&"
import script from "./myThesis.vue?vue&type=script&lang=js&"
export * from "./myThesis.vue?vue&type=script&lang=js&"
import style0 from "./myThesis.vue?vue&type=style&index=0&id=127767c0&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "127767c0",
  null
  
)

export default component.exports